/**
 * Website Theme Configuration
 * Version: 1.0.0
 *
 * SINGLE SOURCE OF TRUTH for theme/palette selection.
 *
 * Philosophy (CLAUDE.md):
 * - Simple, not complex
 * - Single path, no fallbacks
 * - Trust environment variables
 * - No workarounds
 *
 * Usage:
 *   Development: VITE_THEME_PALETTE=logo npm run dev
 *   Production:  Set VITE_THEME_PALETTE=logo in .env.production (or use the
 *                versioned logo default below)
 *
 * Available palettes:
 *   - 'default' (Blue + Yellow)
 *   - 'logo'    (Orange + Teal - matches brand)
 *   - 'earth'   (Brown + Green)
 *   - 'example' (Documented template)
 */

export const THEME_CONFIG = {
  /**
   * Current palette name
   * @type {string}
   */
  // The logo palette is the Public/Web production contract. An explicit
  // VITE_THEME_PALETTE remains available for isolated palette previews.
  palette: import.meta.env.VITE_THEME_PALETTE || 'logo',

  /**
   * Configuration version (for future migrations)
   * @type {string}
   */
  version: '1.0.0'
};

// Development helper: Log current palette
if (import.meta.env.DEV) {
  console.info('[Theme] Loading palette:', THEME_CONFIG.palette);
}
